import clsx from "clsx";
import { Icon } from "@/ui/icon/Icon";
import { stopPropagationEventHandler } from "@/utils/dom";
import type { Calc } from "../../types";
import styles from "./CalculatorCounter.module.css";

interface CalculatorCounterProps {
  value: number;
  counter: Calc.Form.Counter;
  disabled?: boolean;
  className?: string;
  onChange?: (value: number) => void;
}

export const CalculatorCounter: React.FC<CalculatorCounterProps> = ({
  value,
  counter,
  disabled = false,
  className,
  onChange,
}) => {
  const onDecrement = () => {
    onChange?.(Math.max(value - 1, counter.min));
  };

  const onIncrement = () => {
    onChange?.(Math.min(value + 1, counter.max));
  };

  const onInputChange: React.ChangeEventHandler<HTMLInputElement> = (event) => {
    onChange?.(
      Math.min(Math.max(event.target.valueAsNumber, counter.min), counter.max),
    );
  };

  return (
    <div
      className={clsx(styles.counter, disabled && styles.disabled, className)}
      onClick={stopPropagationEventHandler()}
    >
      <div className={styles.btn} onClick={onDecrement}>
        <Icon name="minus_24px_semibold" />
      </div>
      <input
        className={styles.input}
        type="number"
        inputMode="numeric"
        value={value}
        min={counter.min}
        max={counter.max}
        onChange={onInputChange}
      />
      <div className={styles.btn} onClick={onIncrement}>
        <Icon name="plus_24px_semibold" />
      </div>
    </div>
  );
};
